
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h12l5.005 5L12 10H0V0zm1 1v8h10.513l4.01-4-4.01-4H1z"}})])
          )
        }
      }
    